<div #mapImageContainer>
  <img (load)="onLoadedImage($event)" [src]="mapImageUrl">
  <div #mapImage
       (leafletClick)="mapClicked($event)"
       leaflet
       (leafletMapReady)="onMapReady($event)"
       [leafletOptions]="mapOptions">
  </div>
</div>
